(function () {
    const addCanonicalLinkForContent = () => {
        const personalised = document.querySelectorAll('.personalised');
        if (!personalised.length) {
            const link = document.querySelector("link[rel='canonical']")
                ? document.querySelector("link[rel='canonical']")
                : document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute(
                'href',
                `${window.location.protocol}//${
                    window.location.host
                }${window.location.pathname.replace('/qld', '/seq')}`
            );
            document.head.appendChild(link);
        }
    };

    const addCanonicalLinkForPage = () => {
        const personalisedPage = document.querySelector(
            '[data-personalisation-region]'
        );

        let region = null;
        if (personalisedPage !== null) {
            region = personalisedPage.dataset.personalisationRegion;
            region = region.replace('-only', '');

            const link = document.querySelector("link[rel='canonical']")
                ? document.querySelector("link[rel='canonical']")
                : document.createElement('link');
            link.setAttribute('rel', 'canonical');
            let { pathname } = window.location;

            if (region === 'qld') {
                pathname = pathname.replace('/seq', '/qld');
            } else {
                pathname = pathname.replace('/qld', '/seq');
            }
            link.setAttribute(
                'href',
                `${window.location.protocol}//${window.location.host}${pathname}`
            );
            document.head.appendChild(link);
        } else {
            addCanonicalLinkForContent();
        }
    };

    addCanonicalLinkForPage();
})();
